module.exports = __webpack_public_path__ + "static/media/chat-icon.999a982a.svg";